// styles
import styles from './autocomplete.module.scss';

// types
import type { Suggestion } from '../../locator.types';

// components
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { decodingContent } from 'utils/decodingContent';
import { formattedSuggestItemText } from 'utils/locator';
import { classNameBuilder } from 'utils/classNameBuilder';

interface SuggestItemProps {
  suggest: Suggestion;
  selectSuggest: (suggest?: Suggestion) => void;
  index: number;
  cursor: number;
}

export default function SuggestItem({
  selectSuggest,
  suggest,
  suggest: { matchedSubstrings, mainText, secondaryText },
  cursor,
  index,
}: Readonly<SuggestItemProps>) {
  const formattedString = formattedSuggestItemText(matchedSubstrings, mainText);

  return (
    <div
      className={classNameBuilder(cursor === index && 'active', styles.itemWrapper)}
      onMouseDown={() => selectSuggest(suggest)}
      onClick={() => selectSuggest(suggest)}
      onKeyDown={() => selectSuggest(suggest)}
      role="button"
      tabIndex={index}
    >
      <span className={styles.suggestItem}>
        <span className={styles.mainText}>
          {decodingContent(formattedString.pre)}
          <InnerHtml as="b" content={formattedString.matchedSubstring} />
          {decodingContent(formattedString.post)}
        </span>
        <InnerHtml as="span" className={styles.subText} content={secondaryText} />
      </span>
    </div>
  );
}
